import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Envs } from '../envs'

export class MarkPostViewed {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(postId: string, type: 'content' | 'meeting'): Promise<void> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .request({
          url: `${Envs.BFF_WEB_URL}/hub/posts/${postId}/view`,
          method: HttpMethod.PATCH,
          body: { type },
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (![HttpStatusCode.NO_CONTENT, HttpStatusCode.OK].includes(response.statusCode)) {
            return reject(`Ocorreu um erro ao salvar a visualização da publicação`)
          }

          return resolve()
        })
    })
  }
}
